<template>
    <div class="rn-popup-modal report-modal-wrapper modal fade bg-dark/50" id="reportModal" tabindex="-1" aria-hidden="true">
        <button type="button" class="btn-close absolute top-4 right-4 bg-transparent border-0 text-white text-2xl hover:text-primary" data-bs-dismiss="modal" aria-label="Close">
            <i class="feather-x"/>
        </button>
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content report-content-wrapper bg-[var(--background-color-1)] p-6 rounded-lg">
                <div class="modal-header report-modal-header border-b border-[var(--color-border)] pb-4 mb-4">
                    <h5 class="modal-title text-lg font-semibold text-white">
                        Why are you reporting?
                    </h5>
                </div>
                <div class="modal-body">
                    <p class="text-gray-400 mb-4">Describe why you think this item should be removed from marketplace</p>
                    <div class="report-form-box">
                        <h6 class="title text-white font-medium mb-2">Message</h6>
                        <textarea name="message" placeholder="Write issues" class="w-full p-3 bg-[var(--background-color-4)] border border-[var(--color-border)] rounded text-white focus:border-primary focus:outline-none resize-none h-32"></textarea>
                        <div class="report-button flex gap-3 mt-4">
                            <button type="button" class="btn btn-primary px-6 py-2 rounded">Report</button>
                            <button type="button" class="btn btn-primary-alta px-6 py-2 rounded" data-bs-dismiss="modal">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ReportModal'
    }
</script>